import { render, staticRenderFns } from "./sfxDriverAuditForm.vue?vue&type=template&id=42a23437&scoped=true"
import script from "./sfxDriverAuditForm.vue?vue&type=script&lang=js"
export * from "./sfxDriverAuditForm.vue?vue&type=script&lang=js"
import style0 from "./sfxDriverAuditForm.vue?vue&type=style&index=0&id=42a23437&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a23437",
  null
  
)

export default component.exports